const getAutoHeightDuration = (height?: number): number => {
  if (!height) {
    return 0;
  }

  const constant = height / 36;

  // https://www.wolframalpha.com/input/?i=(4+%2B+15+*+(x+%2F+36+)+**+0.25+%2B+(x+%2F+36)+%2F+5)+*+10
  return Math.round((4 + 15 * constant ** 0.25 + constant / 5) * 10);
};

type GetTransitionDuration = (
  duration: number | 'auto',
  height: number
) => number;

const getTransitionDuration: GetTransitionDuration = (duration, height) => {
  if (typeof duration === 'number') {
    return duration;
  } else if (duration === 'auto') {
    return getAutoHeightDuration(height);
  }

  return 0;
};

const getChangeHeight = (
  node: HTMLDivElement,
  prevHeight: number | 'auto',
  height: number | 'auto'
) => {
  const prev = prevHeight === 'auto' ? node.scrollHeight : prevHeight;
  const current = height === 'auto' ? node.scrollHeight : height;

  return Math.abs(current - prev);
};

const getTransition = (
  height: number,
  duration: number | 'auto',
  timingFunction: string
): string =>
  `height ${getTransitionDuration(duration, height)}ms ${timingFunction}`;

export const animate = (
  node: HTMLDivElement,
  prevHeight: number | 'auto',
  height: number | 'auto',
  duration: number | 'auto',
  timingFunction: string,
  animateDisabled: boolean
): void => {
  const transition = !animateDisabled
    ? getTransition(
        getChangeHeight(node, prevHeight, height),
        duration,
        timingFunction
      )
    : '';

  node.style.transition = '';

  window.requestAnimationFrame(() => {
    if (prevHeight !== 'auto') {
      node.style.height = `${prevHeight}px`;
    } else {
      node.style.height = `${node.scrollHeight}px`;
    }

    node.style.transition = transition;

    window.requestAnimationFrame(() => {
      if (height !== 'auto') {
        node.style.height = `${height}px`;
      } else {
        node.style.height = `${node.scrollHeight}px`;
      }
    });
  });
};
